import styled from 'styled-components';
import { fontSize } from '@/public/template/common/css/setting/variable';
export const FeedItemSub = styled.div`
  margin-top: 8px;
  font-size: ${fontSize.px12};
  line-height: 1.1;
  color: ${({ theme }) => theme.news.palette.text_sub_lv1_common};
`;
